import { useEffect } from "react";

import { TabType, MOBILE, ALL } from "@constants";

export const useListenerMobile = (type: TabType) => {
  useEffect(() => {
    // === ELEMENTS
    // filters toggle
    const toggleEl = document.getElementById(`filters-toggle-container-${MOBILE}-${type}-${ALL}`);
    const buttonEl = document.getElementById(`filters-toggle-button-${MOBILE}-${type}-${ALL}`);
    const buttonIcon = document.getElementById(
      `filters-toggle-button-icon-${MOBILE}-${type}-${ALL}`
    );

    // filters hide
    const homeIndicatorEl = document.getElementById(`filters-home-indicator-${type}`);
    const hideButtonEl = document.getElementById(`filters-hide-button-${MOBILE}-${type}`);

    // filters dropdown
    const dropdownEl = document.getElementById(`filters-dropdown-all-${MOBILE}-${type}`);

    // === EVENT LISTENERS
    // filters toggle
    const handleFiltersToggleMobile = () => {
      buttonIcon.classList.toggle("rotate-180"); // design
      toggleEl.classList.toggle("pb-12");
      toggleEl.classList.toggle("pb-2");
      dropdownEl.classList.toggle("hidden"); // visibility
      dropdownEl.classList.toggle("block");
    };

    buttonEl.addEventListener("click", () => {
      handleFiltersToggleMobile();
    });

    // filters hide
    if (homeIndicatorEl) {
      homeIndicatorEl.addEventListener("click", () => {
        handleFiltersToggleMobile();
      });
    }

    if (hideButtonEl) {
      hideButtonEl.addEventListener("click", () => {
        handleFiltersToggleMobile();
      });
    }
  }, []);
};
